import { DisclosurePanel } from 'react-aria-components';
import styled from 'styled-components';

export const Panel = styled(DisclosurePanel)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--spacing-base);
  width: 100%;
  padding-block-start: var(--spacing-large);

  &[hidden="until-found"] {
    padding-block-start: 0;
  }

  & :not(div, textarea) {
    padding-inline: var(--spacing-xsmall);
  }

  & .react-aria-Text {
    width: 100%;
    text-align: right;
  }
`;
